export default function generateSelectOptions(options: any[]): IOption[] {
  return options.map(value => ({
    label: String(value),
    value: value as unknown,
  }))
}
